export default __webpack_public_path__ + "static/media/bullseye-white.c89b522a.svg";